import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { fetchMyStaffInvitations } from '../api/staff';
import StaffMembershipInvites from '../components/staff/StaffMembershipInvites';
import { useAuth } from '../context/AuthContext';

const StaffPendingApprovalPage = () => {
  const { t } = useTranslation();
  const { user, logout } = useAuth();
  const pendingSalons = user?.pendingSalons?.length
    ? user.pendingSalons
    : user?.pendingSalon
      ? [user.pendingSalon]
      : [];

  const { data: inviteData } = useQuery({
    queryKey: ['staff-membership-invitations'],
    queryFn: fetchMyStaffInvitations,
  });
  const hasInvites = (inviteData?.invitations || []).length > 0;

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-50 px-4 dark:bg-zinc-950">
      <div className="w-full max-w-lg rounded-2xl border border-zinc-200 bg-white p-8 dark:border-zinc-800 dark:bg-zinc-900">
        <StaffMembershipInvites />
        <div className="text-center">
          {pendingSalons.length > 0 && (
            <>
              <p className="text-5xl">⏳</p>
              <h1 className="mt-4 text-2xl font-semibold">{t('auth.staffRegister.pendingTitle')}</h1>
              <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">{t('auth.staffRegister.pendingDescMulti')}</p>
              <ul className="mt-4 space-y-2 text-left">
                {pendingSalons.map((salon) => (
                  <li
                    key={salon.tenantId}
                    className="rounded-lg bg-zinc-100 px-4 py-3 text-sm dark:bg-zinc-800"
                  >
                    <p className="font-medium">{salon.businessName}</p>
                    <p className="mt-1 text-xs text-zinc-500">{t('auth.staffRegister.awaitingSalonApproval')}</p>
                  </li>
                ))}
              </ul>
              <p className="mt-4 text-xs text-zinc-500">{t('auth.staffRegister.pendingHelpMulti')}</p>
            </>
          )}
          {!pendingSalons.length && hasInvites && (
            <p className="mt-2 text-sm text-zinc-600 dark:text-zinc-400">{t('staff.invitations.pendingOnlyDesc')}</p>
          )}
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <button
              type="button"
              onClick={() => logout()}
              className="rounded-lg border border-zinc-300 px-4 py-2 text-sm dark:border-zinc-700"
            >
              {t('common.signOut')}
            </button>
            <Link to="/settings/profile" className="rounded-lg bg-glow-600 px-4 py-2 text-sm text-white hover:bg-glow-500">
              {t('nav.profileSettings')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffPendingApprovalPage;
